/**
 * Plantilla de columnas compartida por el encabezado y las filas de la tabla de
 * "Configuración de menús". Debe ser IDÉNTICA en ambos para que cada checkbox
 * quede exactamente bajo su rol (con `1fr` el encabezado y las filas calculan
 * anchos distintos según su contenido y se desalinean).
 */
export const NAME_COL = 220;
export const ROLE_COL = 132;
export const ORDER_COL = 96;

export const menuGridTemplate = (roleCount: number) =>
  `${NAME_COL}px repeat(${roleCount}, ${ROLE_COL}px) ${ORDER_COL}px`;

export const menuGridMinWidth = (roleCount: number) =>
  NAME_COL + roleCount * ROLE_COL + ORDER_COL;
